import type { TextProps } from 'react-native'
import * as Comp from './bottom-sheets-description.styles'

export const BottomSheetsDescription = ({ children }: TextProps) => {
  if (children?.toString() === '') return null

  return <Comp.Description numberOfLines={2}>{children}</Comp.Description>
}
